import { render, staticRenderFns } from "./uploadAct.vue?vue&type=template&id=629a6551&"
import script from "./uploadAct.vue?vue&type=script&lang=js&"
export * from "./uploadAct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports